import React from "react";
import { Badge, Button, Col, Form, NavItem, Row } from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { accountServices } from "../../APIServices/GlobalManagements/accountServices";
import { userServices } from "../../APIServices/UserData/userServices";
import { handleResponse } from "../../APIHelpers/Responses";
import UseToggle from "../../Hooks/UseToggle";

const SelectAccount = ({ organizationList, currentUserData, getCurrectLoginUser }) => {
  const toggles = UseToggle();
  const [loader, setLoader] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [accountList, setAccountList] = useState([]);

  const getAccountList = async (adminId) => {
    setAdminId(adminId)
    setLoader(true)
    let data = await accountServices.getAccountList(adminId, "all")
    setAccountList(data?.data || [])
    setLoader(false)
  }

  const switchLoginAccountAndProperty = async (item) => {
    if (item?.status === "active") {
      if (item?.loginStatus) {
        await handleResponse({
          statusCode: 400,
          customMessage: "Opps! You have already logged In.",
        })
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to login in this account?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, login it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            let userData = {};
            userData.loginAccountId = item?.accountId;
            let data = await userServices.switchLoginAccountAndProperty(userData);
            if (data?.statusCode === 200) {
              getAccountList(adminId);
              getCurrectLoginUser()
            }
          }
        });
      }
    } else {
      await handleResponse({
        statusCode: 400,
        customMessage: "Access denied. This account is currently disabled.",
      })
    }
  };

  const switchToPersonalAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to switch to account?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, switch it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.loginAccountId = "";
        let data = await userServices.switchLoginAccountAndProperty(userData);
        if (data?.statusCode === 200) {
          getAccountList(adminId);
          getCurrectLoginUser()
        }
      }
    });
  };

  useEffect(() => {
    if (organizationList?.length > 0) {
      setAdminId(organizationList?.[0]?.adminId)
    }
  }, [organizationList]);

  useEffect(() => {
    if (adminId) {
      getAccountList(adminId)
    }
  }, [adminId]);
  return (
    <>
      <div className="h-100 d-flex flex-column">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <Form.Group className="lh-1">
              <h6 className="fw-semibold m-0 d-block">Account</h6>
              <Form.Text style={{ fontSize: 13 }} className="text-muted">
                Account store all of your passwords, credit cards, and other items.
              </Form.Text>
            </Form.Group>
            {currentUserData?.loginAccountId &&
              <Button variant="primary" size="sm" onClick={switchToPersonalAccount}>
                Login to Personal
              </Button>
            }
          </div>
        </div>
        {organizationList?.length > 1 &&
          <div className="bg-white border-bottom px-4 py-3">
            <div className="hstack flex-wrap gap-2">
              {organizationList?.map((item, index) => (
                <Button key={index} variant={adminId === item?.adminId ? "primary" : "outline-primary"} size="sm" onClick={() => setAdminId(item?.adminId)}>
                  {item?.name}
                </Button>
              ))}
            </div>
          </div>
        }
        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-4">
            {accountList?.map((item, index) => (
              <Form.Group onClick={() => switchLoginAccountAndProperty(item)} key={index} as={Col} xxl={3} xl={4} lg={6} md={6} sm={12} className="mb-2">
                <button className={`border rounded w-100 d-block align-items-start overflow-hidden text-start p-0`}>
                  <div style={{ fontSize: 14 }} className={`border-bottom py-2 px-3 bg-light`}>
                    <div className="hstack justify-content-between">
                      <div className="fw-bold m-0 text-truncate" title={item?.name}>{item?.name}</div>
                      <div className="hstack gap-2">
                        {item?.category === "primary" ?
                          <Badge bg="primary" className="rounded-1 text-capitalize">Primary</Badge>
                          : item?.status === "inactive" &&
                          <Badge bg="outlinep-secondary" className="text-secondary rounded-1 text-capitalize">Disabled</Badge>
                        }
                      </div>
                    </div>
                  </div>
                  <div style={{ fontSize: 13, height: 180 }} className="py-2 px-3 text-muted overflow-auto bg-white">
                    <p className="mb-1">{item?.totalContact}</p>
                    <p className="mb-1">{item?.totalProperty}</p>
                    <p className="mb-2">{item?.totalMember}</p>
                    <p>{item?.description}</p>
                  </div>
                  <div style={{ fontSize: 14 }} className={`border-top py-2 px-3 hstack justify-content-between`}>
                    <span className={`text-center fw-bold ${item?.status === "active" ? "text-success" : "text-secondary"}`} style={{ fontSize: 12 }}>{item?.status === "active" ? "Login now" : "You can't Login this account"}</span>
                  </div>
                </button>
              </Form.Group>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};

export default SelectAccount;
